
import { Attribute, firstValue, firstValueAsString } from '../../../Types/Attribute';
import { RapsInfoElement } from './RapsInfoElement';
import { SustainabilityElement } from './SustainabilityElement';



interface TwoColumnProps {
    keyValuePairs: [string, Attribute][];
}

export function TwoColumns(props: TwoColumnProps) {
    return (
        <div className="bg-primary px-4">
            <div className="grid grid-cols-2 gap-y-4 border-dotted">


                {props.keyValuePairs.map(([key, value], index) => (
                    <RapsInfoElement
                        key={key}
                        name={key}
                        value={firstValueAsString(value) ?? 'null'}
                        uom={value?.Uom ?? ""}
                        class={index % 2 === 0 ? 'text-left' : 'text-right'}
                    />
                ))}

            </div>
        </div>
    );
}

interface ColumnProps {
    keyValuePairs: { [key: string]: string | null | undefined };
}
export function OneColumn(columnProps: ColumnProps) {

    return (
        <div className="px-4">
            <div className="grid grid-cols-1 gap-y-4" style={{ border: 'none' }}>
                {Object.entries(columnProps.keyValuePairs).map(([key, value]) => (
                    <SustainabilityElement
                        key={key}
                        name={key}
                        value={value != null ? value.toString() : 'null'}
                    />
                ))}
            </div>
        </div>
    );
}




